"use client";

import { useEffect } from "react";

import { useIntersectionObserver } from "../../hooks/useIntersectionObserver";

const getObserverRootMargin = (shouldPreloadNextFeedPage: boolean) => {
  return shouldPreloadNextFeedPage ? "100% 0px" : "0px";
};

const useFeedPaginationObserver = ({
  fetchUrl,
  isLoading,
  loadMoreFeedData,
  shouldPreloadNextFeedPage,
}: {
  fetchUrl: string;
  isLoading: boolean;
  loadMoreFeedData: (url: string) => void;
  shouldPreloadNextFeedPage: boolean;
}) => {
  const [ref, entry] = useIntersectionObserver<HTMLDivElement>({
    rootMargin: getObserverRootMargin(shouldPreloadNextFeedPage),
    threshold: 0,
  });
  const isIntersecting = entry?.isIntersecting ?? false;

  useEffect(() => {
    if (!isIntersecting || !fetchUrl || isLoading) {
      return;
    }

    loadMoreFeedData(fetchUrl);
  }, [fetchUrl, isIntersecting, isLoading, loadMoreFeedData]);

  return ref;
};

export { useFeedPaginationObserver };
